import Box from '@zenbusiness/zui/Box';
import { styled } from '@zenbusiness/zui/styles';

const ChartContainerStyles = ({ theme }) => ({
  border: `1px solid ${theme.palette.border.main}`,
  backgroundColor: `${theme.palette.background.grey.light}`,
  borderRadius: 16,
  padding: 16,
  [theme.breakpoints.up('md')]: {
    padding: 24
  }
});

export const ChartContainer = styled(Box)(ChartContainerStyles);
